import styles from './DropDownResults.module.css';
import { SelectedItem, MultiSelectDropDownOption } from './types';
import { SELECTION_TYPES, SelectionType } from './constants';

interface ActionButtonsProps {
  option: MultiSelectDropDownOption;
  group?: string;
  status?: SelectedItem;
  onItemSelect: (value: string, group?: string, type?: SelectionType, label?: string) => void;
}

const ActionButtons = ({ option, group, status, onItemSelect }: ActionButtonsProps) => (
  <div className={styles.actionButtons}>
    <button
      className={`${styles.actionButton} ${styles.includeButton} ${status?.type === SELECTION_TYPES.INCLUDE ? styles.active : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onItemSelect(option.id, group, SELECTION_TYPES.INCLUDE, option.value);
      }}
    >
      Include
    </button>
    <button
      className={`${styles.actionButton} ${styles.excludeButton} ${status?.type === SELECTION_TYPES.EXCLUDE ? styles.active : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onItemSelect(option.id, group, SELECTION_TYPES.EXCLUDE, option.value);
      }}
    >
      Exclude
    </button>
  </div>
);

export default ActionButtons;
